import { render, staticRenderFns } from "./SignatureInbox.vue?vue&type=template&id=97e202d2"
import script from "./SignatureInbox.vue?vue&type=script&lang=js"
export * from "./SignatureInbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports